import { AuthTokenPayload, PrincipalType } from "@vertesia/common"

export function getInitials(name?: string | undefined) {
    if (!name) {
        return "U"
    }

    const nameParts = name.split(" ")
    const initials = nameParts
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .slice(0, 2)
    return initials
}

export function getFirstName(name?: string | undefined) {
    if (!name) {
        return "User"
    }

    const nameParts = name.split(" ")
    return nameParts[0]
}

export function isAdmin(user: AuthTokenPayload | undefined) {
    if (!user) {
        return false
    }

    const roles = (user as any)?.project_roles || []
    if (!Array.isArray(roles) || roles.length === 0) {
        return false
    }

    return roles.includes("admin")
}